import { useNavigate } from "react-router-dom";
import { useLang } from "../../contexts/LangContext";
import { useLogSession } from "../../contexts/LogSessionContext";
import { useEffect } from "react";

export default function AbortLog() {
  const { t } = useLang();
  const navigate = useNavigate();
  const { 
    mode, 
    person,
    setcurrentMealRecord, 
    setcurrentDayRecord, 
    setNewFishItem,
    exitFallback
  } = useLogSession();

  useEffect(() => {
    // Don't reset session state here - user might go back
  }, []);

  const handleYes = () => {
    // Clear session and end the log
    setcurrentDayRecord(null);
    setcurrentMealRecord(null);
    setNewFishItem(null);
    
    // Navigate to exit fallback
    navigate(
      exitFallback || (mode === "survey" ? "/survey/person-list" : "/user"),
      { replace: true }
    );
  };

  const handleGoBack = () => {
    // Go back to the when-last-time page without clearing session
    navigate(-1);
  };

  return (
    <div className="flex flex-col items-center justify-center grow text-center px-scr gap-10 mt-8">
      <div className="flex flex-col items-center gap-6">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          strokeWidth="1.5" 
          stroke="currentColor" 
          className="w-20 h-20 text-amber-600"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" 
          />
        </svg>
        
        <h1 className="text-2xl font-bold text-amber-700">
          {t("abortLog_Heading")}
        </h1>
        
        <p className="text-gray-600 text-lg">
          {t("abortLog_SubText")}
        </p>
      </div>

      <div className="flex flex-col gap-4 w-full max-w-sm">
        <button
          type="button"
          onClick={handleYes}
          className="w-full button-base button-bg-grad-red flex items-center justify-center gap-2"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            strokeWidth="1.5" 
            stroke="currentColor" 
            className="size-6"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" 
            />
          </svg>
          <span>{t("abortLog_YesEnd")}</span>
        </button>

        <button
          type="button"
          onClick={handleGoBack}
          className="w-full button-base button-bg-grad-2 flex items-center justify-center gap-2"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            strokeWidth="1.5" 
            stroke="currentColor" 
            className="size-6"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" 
            />
          </svg>
          <span>{t("abortLog_GoBack")}</span>
        </button>
      </div>
    </div>
  );
}